export default __webpack_public_path__ + "386936ae46cd7d8acff657ed5ad72d64.woff";